import React from 'react';

import { useTranslation } from 'react-i18next';

import BlockList from 'components/application/BlockList';

import PersonnelCourseTrainingStatusIndicator from 'components/personnel/PersonnelCourseTrainingStatusIndicator';

import { personDisplayName } from 'components/helpers/users';

export default function SubcontractorSidePanelPersonnelTab({
  isLoadMorePersonnelActive,
  loadMoreRef,
  personnel,
  personnelMeta,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'subcontractors.shared',
  });

  const { t: i18nTPersonnel } = useTranslation('common', {
    keyPrefix: 'personnel',
  });

  return (
    <div key='personnelTab' label='personnel'>
      {personnel.loaded && personnel.collection.length === 0 ?
        <li className='block-list__item tw-border-grey-100'>
          <div className='block-list__item--flex-container'>
            <div className='block-list__item--align-center'>
              <span>{i18nT('emptyState')}</span>
            </div>
          </div>
        </li>
      : <>
          <BlockList
            collection={personnel.collection}
            onItemClick={(person) => {
              window.location.replace(`personnel/${person.id}`);
            }}
            onItemDisplay={(person) => (
              <div className='block-list__item--flex-container'>
                <div className='block-list__item--align-center'>
                  <PersonnelCourseTrainingStatusIndicator
                    status={person.attributes.trainingStatus}
                  />
                </div>
                <div className='block-list__item--text tw-max-w-[300px]'>
                  <span className='truncated-text-container'>
                    {personDisplayName({ attributes: person.attributes })}
                  </span>
                </div>
              </div>
            )}
          />
          {isLoadMorePersonnelActive && !personnelMeta.isLastPage && (
            <li
              className='block-list__item tw-border-grey-100'
              ref={loadMoreRef}
            >
              <div className='block-list__item--flex-container'>
                <div className='block-list__item--align-center'>
                  <span>{i18nTPersonnel('loadingPersonnel')}</span>
                </div>
              </div>
            </li>
          )}
        </>
      }
    </div>
  );
}
